/**
 * Loads Google Tag Manager (the standard gtm.js snippet, injected programmatically),
 * mirroring the website's loader (hookdeck/website#688). The <noscript> iframe
 * fallback is intentionally omitted — no-JS visitors never reach this code anyway.
 */

declare global {
  interface Window {
    dataLayer?: { event?: string; [key: string]: unknown }[];
  }
}

export const loadGTM = () => {
  // Never load in development (keeps local traffic out of GTM, same as Dub) or
  // when no GTM_ID is configured.
  if (typeof window === 'undefined' || !VITE_GTM_ID || VITE_APP_ENV === 'development') return;
  window.dataLayer = window.dataLayer || [];
  if (window.dataLayer.some((entry) => entry && entry.event === 'gtm.js')) return;
  window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${VITE_GTM_ID}`;
  const first_script = document.getElementsByTagName('script')[0];
  first_script?.parentNode?.insertBefore(script, first_script);
};
